/*
 * Copyright (C) Luna Srl - All Rights Reserved
 *
 * @project    bfree-frontend.nosync
 * @file       LogoBFreeSmallImage.tsx
 * @author     Christian Ascone
 * @date       9/24/19 12:52 PM
 */

import React from 'react';
import {Image} from "react-native";
import {imageUri} from "../../models/ImageUri";

export function QrCodeIcon(props) {
    return (
        <Image
            {...props}
            style={[props.style, {scale: 1.5}]}
            source={
                imageUri.qr_code.uri
            }
        />
    );
}